import script from "./ColisConfirmed.vue?vue&type=script&setup=true&lang=js"
export * from "./ColisConfirmed.vue?vue&type=script&setup=true&lang=js"

import "./ColisConfirmed.vue?vue&type=style&index=0&id=39ebec5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ebec5b"]])

export default __exports__